export default __webpack_public_path__ + "static/appstore_download-aab1889c452fb82e2cb16c1d2675031c.svg";